(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const getAsiabFilterEls = () => ({
    container: document.querySelector('.product-grid-container--asiab'),
    trigger: document.querySelector('.product-grid-container--asiab .asiab-filter-trigger'),
    host: document.querySelector('.product-grid-container--asiab #filters-drawer'),
    drawer: document.querySelector('.product-grid-container--asiab #filters-drawer .facets--drawer'),
  });

  const positionAsiabFilterPanel = () => {
    const { trigger, drawer } = getAsiabFilterEls();
    if (!trigger || !drawer) return;

    const triggerRect = trigger.getBoundingClientRect();
    const panelWidth = Math.min(280, window.innerWidth - 32);
    const left = Math.min(Math.max(16, triggerRect.left), window.innerWidth - panelWidth - 16);
    const top = Math.min(triggerRect.bottom + 10, window.innerHeight - 40);

    drawer.style.setProperty('--asiab-filter-panel-left', `${left}px`);
    drawer.style.setProperty('--asiab-filter-panel-top', `${top}px`);
  };

  const closeAsiabFilterPanel = () => {
    const { host, drawer } = getAsiabFilterEls();
    if (!drawer?.open) return;
    if (host && typeof host.closeDialog === 'function') {
      host.closeDialog();
    } else {
      try { drawer.close(); } catch (_) { /* ignore */ }
    }
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('.product-grid-container--asiab .asiab-filter-trigger')) {
      positionAsiabFilterPanel();
      requestAnimationFrame(positionAsiabFilterPanel);
    }
  }, true);

  // Escape key — close the panel regardless of focus location.
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const { drawer } = getAsiabFilterEls();
    if (!drawer?.open) return;
    event.preventDefault();
    event.stopPropagation();
    closeAsiabFilterPanel();
  }, true);

  // Native dialog close (e.g. browser Escape) — restore the scroll-locked body.
  document.addEventListener('close', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLDialogElement)) return;
    if (!target.classList.contains('facets--drawer')) return;
    if (!target.closest('.product-grid-container--asiab')) return;
    if (document.body.style.position === 'fixed') {
      const offset = parseInt(document.body.style.top || '0', 10) || 0;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo({ top: -offset, behavior: 'instant' });
    }
  }, true);

  window.addEventListener('resize', positionAsiabFilterPanel);
  window.addEventListener('scroll', positionAsiabFilterPanel, { passive: true });

  // Reposition after AJAX filter updates (when the product grid section re-renders
  // and the trigger button shifts) so the panel keeps tracking its anchor.
  const observeAsiabSection = () => {
    const section = document.querySelector('.product-grid-container--asiab');
    if (!section) return;
    const repositionOnMutation = () => {
      const drawer = document.querySelector(
        '.product-grid-container--asiab #filters-drawer .facets--drawer'
      );
      if (drawer?.open) {
        requestAnimationFrame(() => {
          positionAsiabFilterPanel();
          requestAnimationFrame(positionAsiabFilterPanel);
        });
      }
    };
    new MutationObserver(repositionOnMutation).observe(section, {
      childList: true,
      subtree: true,
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAsiabSection, { once: true });
  } else {
    observeAsiabSection();
  }

  // Working two-handle price slider that drives the native price-facet text inputs.
  const initAsiabPriceSlider = () => {
    const wrapper = document.querySelector(
      '.product-grid-container--asiab #filters-drawer .price-facet__inputs-wrapper'
    );
    if (!wrapper || wrapper.dataset.asiabSliderReady === '1') return;
    const minInput = wrapper.querySelector('input[id$="-GTE-dialog"]');
    const maxInput = wrapper.querySelector('input[id$="-LTE-dialog"]');
    if (!minInput || !maxInput) return;

    const rangeMax = Math.max(
      1,
      Math.round(parseFloat(maxInput.dataset.max) || parseFloat(maxInput.placeholder) || 200)
    );
    const parseVal = (input, fallback) => {
      const n = parseFloat(input.value);
      return Number.isFinite(n) ? Math.round(n) : fallback;
    };

    const slider = document.createElement('div');
    slider.className = 'asiab-price-slider';
    slider.innerHTML = `
      <div class="asiab-price-slider__labels">
        <span class="asiab-price-slider__label-min">$0</span>
        <span class="asiab-price-slider__label-max">$${rangeMax}+</span>
      </div>
      <div class="asiab-price-slider__track">
        <div class="asiab-price-slider__range-fill"></div>
        <input
          type="range"
          class="asiab-price-slider__input asiab-price-slider__input--min"
          min="0"
          max="${rangeMax}"
          step="1"
          aria-label="Minimum price"
        >
        <input
          type="range"
          class="asiab-price-slider__input asiab-price-slider__input--max"
          min="0"
          max="${rangeMax}"
          step="1"
          aria-label="Maximum price"
        >
      </div>
    `;
    wrapper.appendChild(slider);

    const rangeMin = slider.querySelector('.asiab-price-slider__input--min');
    const rangeMaxEl = slider.querySelector('.asiab-price-slider__input--max');
    const fill = slider.querySelector('.asiab-price-slider__range-fill');

    rangeMin.value = String(parseVal(minInput, 0));
    rangeMaxEl.value = String(parseVal(maxInput, rangeMax));

    const updateFill = () => {
      const minV = Number(rangeMin.value);
      const maxV = Number(rangeMaxEl.value);
      const lo = Math.min(minV, maxV);
      const hi = Math.max(minV, maxV);
      fill.style.left = `${(lo / rangeMax) * 100}%`;
      fill.style.right = `${100 - (hi / rangeMax) * 100}%`;
    };

    const writeToText = (input, value, isMax) => {
      const empty = (!isMax && value === 0) || (isMax && value === rangeMax);
      input.value = empty ? '' : String(value);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };

    let commitTimer;
    const scheduleCommit = () => {
      clearTimeout(commitTimer);
      commitTimer = setTimeout(() => {
        let minV = Number(rangeMin.value);
        let maxV = Number(rangeMaxEl.value);
        if (minV > maxV) [minV, maxV] = [maxV, minV];
        writeToText(minInput, minV, false);
        writeToText(maxInput, maxV, true);
      }, 250);
    };

    [rangeMin, rangeMaxEl].forEach((input) => {
      input.addEventListener('input', () => {
        updateFill();
        scheduleCommit();
      });
    });

    updateFill();
    wrapper.dataset.asiabSliderReady = '1';
  };

  // Inject a "Clear All" pill at the end of the active filter chips.
  const ensureAsiabClearAllPill = () => {
    const pillRow = document.querySelector(
      '.product-grid-container--asiab #filters-drawer .facets-remove'
    );
    const hiddenClearAll = document.querySelector(
      '.product-grid-container--asiab #filters-drawer .facets__clear-all'
    );
    if (!pillRow) return;
    const hasActive = pillRow.querySelector('.facets-remove__pill');
    let pill = pillRow.querySelector('.asiab-clear-all-pill');
    if (!hasActive) {
      pill?.remove();
      return;
    }
    if (pill) return;
    pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'asiab-clear-all-pill';
    pill.textContent = 'Clear All';
    pill.addEventListener('click', () => {
      hiddenClearAll?.click();
    });
    pillRow.appendChild(pill);
  };

  // Try to init on page load and again every time the panel opens.
  const tryInitPriceSlider = () => {
    initAsiabPriceSlider();
    requestAnimationFrame(initAsiabPriceSlider);
    ensureAsiabClearAllPill();
  };
  document.addEventListener('DOMContentLoaded', tryInitPriceSlider);
  document.addEventListener('click', (event) => {
    if (event.target.closest('.product-grid-container--asiab .asiab-filter-trigger')) {
      setTimeout(tryInitPriceSlider, 50);
      setTimeout(tryInitPriceSlider, 250);
    }
  }, true);
  // Re-init after AJAX filter updates re-render the price-facet component.
  document.addEventListener('dialog:open', tryInitPriceSlider);
  new MutationObserver(() => {
    const wrapper = document.querySelector(
      '.product-grid-container--asiab #filters-drawer .price-facet__inputs-wrapper'
    );
    if (wrapper && wrapper.dataset.asiabSliderReady !== '1') tryInitPriceSlider();
    ensureAsiabClearAllPill();
  }).observe(document.documentElement, { childList: true, subtree: true });


  } catch(e) { console.error(e); }
})();
})();
